import React, { useState, useEffect } from 'react';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import ReactDOM from 'react-dom';

const PayPalButton = (props) => {

    //static propTypes = {
    //    amount: PropTypes.oneOfType([
    //        PropTypes.number,
    //        PropTypes.string,
    //    ]),
    //    currency: PropTypes.oneOfType([
    //        PropTypes.number,
    //        PropTypes.string,
    //    ]),
    //    shippingPreference: PropTypes.string,
    //    onSuccess: PropTypes.func,
    //    catchError: PropTypes.func,
    //    onError: PropTypes.func,
    //    createOrder: PropTypes.func,
    //    createSubscription: PropTypes.func,
    //    onApprove: PropTypes.func,
    //    style: PropTypes.object,
    //    options: PropTypes.shape({
    //        clientId: PropTypes.string,
    //        merchantId: PropTypes.string,
    //        currency: PropTypes.oneOfType([
    //            PropTypes.number,
    //            PropTypes.string,
    //        ]),
    //        intent: PropTypes.string,
    //        commit: PropTypes.oneOfType([
    //            PropTypes.bool,
    //            PropTypes.string
    //        ]),
    //        vault: PropTypes.oneOfType([
    //            PropTypes.bool,
    //            PropTypes.string
    //        ]),
    //        component: PropTypes.string,
    //        disableFunding: PropTypes.string,
    //        disableCard: PropTypes.string,
    //        integrationDate: PropTypes.string,
    //        locale: PropTypes.string,
    //        buyerCountry: PropTypes.string,
    //        debug: PropTypes.oneOfType([
    //            PropTypes.bool,
    //            PropTypes.string
    //        ])
    //    }),
    //    onButtonReady: PropTypes.func,
    //}

    const defaultCheckoutType = 'order';

    const [isSdkReady, setIsSdkReady] = useState(false);
    const [isMount, setIsMount] = useState(true);

    useEffect(() => {
        if (isMount) {
            if (
                typeof window !== 'undefined' &&
                window !== undefined &&
                window.paypal === undefined
            ) {
                if (props.loadSdk) {
                    addPaypalSdk();
                }
            } else if (
                typeof window !== 'undefined' &&
                window !== undefined &&
                window.paypal !== undefined &&
                props.onButtonReady
            ) {
                props.onButtonReady();
            }
            setIsMount(false);
        }

        if (props.isSdkReady) {
            setIsSdkReady(true);
        }
    }, [props.isSdkReady]);

    useEffect(() => {
        if (isSdkReady) {
            props.ready?.();        
        }
    }, [isSdkReady]);

    const addPaypalSdk = () => {
        const {
            options,
            onButtonReady,
            attributionId = 'Sandhills_MP',
            orderId
        } = props;
        const queryParams = [];

        // replacing camelCase with dashes
        Object.keys(options).forEach(k => {
            const name = k.split(/(?=[A-Z])/).join('-').toLowerCase();
            queryParams.push(`${name}=${options[k]}`);
        });
        
        const script = document.createElement('script');
        if (props.scriptID) {
            script.setAttribute("id", props.scriptID);
        }
        script.type = 'text/javascript';
        script.src = `https://www.paypal.com/sdk/js?${queryParams.join('&')}`;
        script.async = true;
        if (attributionId) script.setAttribute('data-partner-attribution-id', attributionId);
        if (orderId) script.setAttribute('data-order-id', orderId)
        script.onload = () => {
            setIsSdkReady(true);
            if (onButtonReady) {
                onButtonReady();
            }
        };
        script.onerror = () => {
            throw new Error('Paypal SDK could not be loaded.');
        };

        document.body.appendChild(script);
    };
    
    const defaultCreateOrder = (data, actions) => {
        if (props.orderId) {
            return props.orderId;
        } else {
            const {
                baseUrl = '/shop/',
                checkoutType = defaultCheckoutType,
                productId,
                quantity,
                checkoutInfo
            } = props;

            const queryString = (productId ? ('?productId=' + productId + (quantity ? '&quantity=' + quantity : '')) : '');
            return sandhillsRequest({
                url: baseUrl + 'paypal/' + checkoutType + queryString,
                method: 'post',
                data: JSON.stringify(checkoutInfo),
                headers: {
                    'Content-Type': 'application/json'
                },
                errorHandling: {
                    useConsole: false,
                    useAlert: false
                }
            }).then((data) => {
                return data.id;
            }).catch(() => {
                return null;
            });
        }
    };

    const defaultOnApprove = (data, actions) => {
        const {
            baseUrl = '/shop/',
            checkoutType = defaultCheckoutType,
            beforeRedirect
        } = props;

        if (beforeRedirect) {
            beforeRedirect();
        }

        window.location = baseUrl + 'paypal/' + checkoutType + '/review/?token=' + data.orderID;
    };

    const defaultStyle = {
        layout: 'horizontal',
        color: 'gold',
        shape: 'rect',
        label: 'checkout',
        height: 32,
        tagline: false
    };

    const {
        createOrder,
        onApprove,
        style
    } = props;

    if (!isSdkReady && (typeof window === 'undefined' || window.paypal === undefined)) {
        return (<></>);
    }

    const Button = window.paypal.Buttons.driver('react', {
        React,
        ReactDOM,
    });

    const createOrderFn =
        createOrder
            ? (data, actions) => createOrder(data, actions)
            : (data, actions) => defaultCreateOrder(data, actions);

    const onApproveFn =
        onApprove
            ? (data, actions) => onApprove(data, actions)
            : (data, actions) => defaultOnApprove(data, actions);

    return (
        <Button
            {...props}
            createOrder={createOrderFn}
            onApprove={onApproveFn}
            style={{
                ...defaultStyle,
                ...style
            }}
        />
    );
};

export default PayPalButton;